<template>
  <span
      class="newsletter-subscribe-wrapper"
      data-toggle="modal"
      data-target="#newsletter-subscribe"
      :data-load-url="'/mail-subscription/form/verhuurd/' + rentalShortId + '/'"
      data-load-method="GET"
      @click.prevent
  >
    <slot></slot>
  </span>
</template>
<script>

export default {
  name: "adivare-newsletter-subscribe-wrapper",
  props: {
    rentalShortId: [String],
  },
}
</script>
